var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.531,
    height: 114.081,
    viewBox: "0 0 127.531 114.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_921305",
    "data-name": 921305,
    transform: "translate(-0.001 -13.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    "data-name": "Grupo 389",
    transform: "translate(19.086 117.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_210",
    "data-name": "Trazado 210",
    d: "M84.9,477.123l-3.75-5.282a2.491,2.491,0,1,0-4.062,2.884l3.75,5.282a2.491,2.491,0,1,0,4.062-2.884Z",
    transform: "translate(-76.624 -470.791)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    "data-name": "Grupo 391",
    transform: "translate(0.001 38.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_390",
    "data-name": "Grupo 390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_211",
    "data-name": "Trazado 211",
    d: "M56.1,242.01l-4.081-19.45A36.682,36.682,0,0,0,36.5,199.531l-8.713-5.859a8.765,8.765,0,0,0-11.11,1.134V164.792a8.338,8.338,0,0,0-13.557-6.5,8.3,8.3,0,0,0-3.12,6.5v38.621a24.127,24.127,0,0,0,4.477,14.041l4.442,6.257a2.491,2.491,0,0,0,4.062-2.884L8.54,214.57a19.172,19.172,0,0,1-3.558-11.157V164.792a3.357,3.357,0,1,1,6.713,0v30.641a17.4,17.4,0,0,0,4.489,11.685c.124.149.252.3.386.439,1.654,1.753,3.6,3.818,5.431,5.765l2.564,2.729.026.025c2.194,2.333,3.811,4.056,3.845,4.092a2.491,2.491,0,1,0,3.631-3.41c-.045-.048-2.961-3.153-6.291-6.692l-5.711-6.078-.042-.047a4.2,4.2,0,0,1,.081-5.508,3.766,3.766,0,0,1,4.9-.626l8.713,5.859a31.725,31.725,0,0,1,13.418,19.918l4.081,19.451A2.491,2.491,0,1,0,56.1,242.01Z",
    transform: "translate(-0.001 -156.451)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_393",
    "data-name": "Grupo 393",
    transform: "translate(13.921 109.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_392",
    "data-name": "Grupo 392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_212",
    "data-name": "Trazado 212",
    d: "M60.419,442.642l-.016-.022a2.491,2.491,0,0,0-4.055,2.893l.016.022a2.491,2.491,0,0,0,4.055-2.893Z",
    transform: "translate(-55.884 -441.575)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_395",
    "data-name": "Grupo 395",
    transform: "translate(71.383 38.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_394",
    "data-name": "Grupo 394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_213",
    "data-name": "Trazado 213",
    d: "M339.609,158.291a8.338,8.338,0,0,0-13.557,6.5v30.014a8.765,8.765,0,0,0-11.11-1.134l-8.713,5.859a36.681,36.681,0,0,0-15.514,23.029l-4.081,19.451a2.491,2.491,0,1,0,4.875,1.023l4.081-19.451a31.726,31.726,0,0,1,13.418-19.918l8.713-5.859a3.766,3.766,0,0,1,4.9.626,4.2,4.2,0,0,1,.086,5.5l-.047.053-12,12.771a2.491,2.491,0,1,0,3.631,3.41c.034-.036,10.212-10.858,11.866-12.611.135-.143.262-.29.386-.439a17.4,17.4,0,0,0,4.489-11.685V164.794a3.357,3.357,0,1,1,6.714,0v38.621a19.172,19.172,0,0,1-3.558,11.157l-18.819,26.509a2.491,2.491,0,1,0,4.062,2.884l18.818-26.509a24.127,24.127,0,0,0,4.477-14.041V164.794A8.3,8.3,0,0,0,339.609,158.291Z",
    transform: "translate(-286.58 -156.454)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_397",
    "data-name": "Grupo 397",
    transform: "translate(23.263 13.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_396",
    "data-name": "Grupo 396"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_214",
    "data-name": "Trazado 214",
    d: "M165.442,88.289,161.01,87.23v-.795a11.141,11.141,0,0,0,4.769-9.134V71.54A11.139,11.139,0,0,0,147.4,63.068a14.544,14.544,0,0,0-26.955.02,11.139,11.139,0,0,0-18.4,8.452V77.3a11.141,11.141,0,0,0,4.769,9.134v.795l-4.431,1.059A11.669,11.669,0,0,0,93.39,99.674v4.652a2.491,2.491,0,0,0,2.491,2.491h11.446c-.018.3-.03.606-.03.912v8.957a2.491,2.491,0,0,0,2.491,2.491H124.76a2.491,2.491,0,1,0,0-4.982h-2.574v-5.147a2.491,2.491,0,1,0-4.982,0V114.2h-4.926V107.73a10.313,10.313,0,0,1,7.934-10.06l6.835-1.638,4.574,10.407a2.491,2.491,0,0,0,2.28,1.489h0a2.491,2.491,0,0,0,2.28-1.488l4.57-10.392,6.814,1.628a10.312,10.312,0,0,1,7.942,10.062V114.2h-4.926v-5.148a2.491,2.491,0,1,0-4.982,0V114.2h-2.823a2.491,2.491,0,0,0,0,4.982H158a2.491,2.491,0,0,0,2.491-2.491v-8.949c0-.309-.012-.614-.03-.919h11.478a2.491,2.491,0,0,0,2.491-2.491V99.675A11.668,11.668,0,0,0,165.442,88.289ZM154.631,65.374a6.174,6.174,0,0,1,6.153,5.76h-3.463A18.155,18.155,0,0,1,148.97,69.1,6.175,6.175,0,0,1,154.631,65.374Zm-6.166,11.564c0-.121.009-.242.009-.364V74.355a23.138,23.138,0,0,0,8.847,1.76H160.8V77.3a6.166,6.166,0,1,1-12.333,0Zm-24.107-8.388h0a9.568,9.568,0,0,1,19.014-1.52l-4.193-2.464a2.49,2.49,0,0,0-3.171.548,10.732,10.732,0,0,1-8.245,3.848h-3.4v-.412Zm-11.17-3.175a6.175,6.175,0,0,1,5.662,3.724,18.156,18.156,0,0,1-8.352,2.036h-3.463A6.174,6.174,0,0,1,113.187,65.374Zm-6.166,10.741H110.5a23.139,23.139,0,0,0,8.856-1.764V77.3a6.166,6.166,0,0,1-12.333,0V76.115Zm12.031,16.71a15.276,15.276,0,0,0-10.585,9.011h-10.1V99.675a6.7,6.7,0,0,1,5.162-6.541l6.344-1.515A2.491,2.491,0,0,0,111.79,89.2v-.837a10.813,10.813,0,0,0,2.785,0v.711c0,.037,0,.074,0,.111a2.495,2.495,0,0,0,2.024,2.451l3.716.89ZM126,88.958a11.687,11.687,0,0,0-1.994-.673l-4.45-1.066v-.776a11.239,11.239,0,0,0,2.159-1.972,14.664,14.664,0,0,0,4.285,4.3Zm10.818,3.66L133.9,99.247,130.982,92.6V90.823a14.6,14.6,0,0,0,5.836.009Zm-2.894-6.477a9.578,9.578,0,0,1-9.567-9.567V73.942h3.4a15.694,15.694,0,0,0,10.584-4.089l5.137,3.018v4.066A9.577,9.577,0,0,1,133.925,86.14Zm7.875,2.825V88.8a14.659,14.659,0,0,0,4.321-4.306,11.237,11.237,0,0,0,2.141,1.951v.776l-4.45,1.066A11.73,11.73,0,0,0,141.8,88.966Zm27.647,12.87h-10.13a15.273,15.273,0,0,0-10.592-9.007l-1.251-.3,3.736-.9a2.493,2.493,0,0,0,2.035-2.453c0-.019,0-.039,0-.059V88.36a10.813,10.813,0,0,0,2.785,0V89.2a2.491,2.491,0,0,0,1.912,2.423l6.344,1.515a6.7,6.7,0,0,1,5.163,6.541v2.161Z",
    transform: "translate(-93.39 -54)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_399",
    "data-name": "Grupo 399",
    transform: "translate(61.275 73.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_398",
    "data-name": "Grupo 398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_215",
    "data-name": "Trazado 215",
    d: "M250.252,296.4a2.492,2.492,0,1,0,.73,1.764A2.511,2.511,0,0,0,250.252,296.4Z",
    transform: "translate(-246 -295.67)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.cef4ab0a61b31576142ff2ea019d1337.svg";
export { ForwardRef as ReactComponent };